import { PriceList } from '@acme/b2b/pricing/price-list.type';
import { BasePriceFilterModule } from '@b2b/common/filters';
import { ApiService } from '@b2b/common/services/api/types';
import { ColumnDef, input, output, TODO } from '@b2b/types/core';
import angular, { IScope, ITimeoutService } from 'angular';

PriceListPickerDirective.$inject = ['$timeout', 'ApiService', 'HelpersService', 'uiGridConstants'];

function PriceListPickerDirective(
  $timeout: ITimeoutService,
  ApiService: ApiService,
  HelpersService: TODO,
  uiGridConstants: TODO
) {
  class PriceListPickerController {
    static $inject = ['$scope'];

    enableSalesTax = input.required(false);
    hideChannels = input.required(false);
    selectedPriceList = input.required<PriceList | null>(null);
    selectedPriceListChange = output<{ priceList: PriceList | null }>();

    model = [] as PriceList[];
    selected = {} as TODO;
    gridHeight = {
      height: '42px',
    };

    gridOptions = {
      enableRowSelection: false,
      multiSelect: false,
      paginate: false,
      showFooter: false,
    };

    columns = [
      {
        field: 'personType.displayOrder',
        displayName: 'Order',
        visible: false,
      },
      {
        field: 'personType.name',
        displayName: 'Ticket Type',
        sort: {
          direction: uiGridConstants.ASC,
        },
      },
      {
        field: 'personType.description',
        displayName: 'Description',
      },
      {
        field: 'price',
        displayName: 'Price',
        cellFilter: 'currency',
        enableCellEdit: true,
      },
      {
        field: 'salesChannels[0].enabled',
        displayName: 'Web',
        cellTemplate: `<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /></div>`,
        visible: true,
      },
      {
        field: 'salesChannels[1].enabled',
        displayName: 'POS',
        cellTemplate: `<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /></div>`,
        visible: true,
      },
      {
        field: 'salesChannels[2].enabled',
        displayName: 'Reseller',
        cellTemplate: `<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /></div>`,
        visible: true,
      },
    ] as ColumnDef[];

    isLoaded = false;

    constructor(
      private $scope: IScope & {
        priceListPicker: TODO;
      }
    ) {}

    $onInit() {
      if (this.enableSalesTax) {
        const priceColumnIndex = this.columns.findIndex((column) => column.field === 'price');

        /**
         * Insert after `basePrice` after `price` column
         */
        this.columns.splice(priceColumnIndex + 1, 0, {
          field: 'basePrice',
          displayName: 'Base Price',
          cellFilter: 'basePrice',
          enableCellEdit: true,
        });
      }

      if (this.hideChannels) {
        for (const columns of this.columns) {
          if (columns.field.startsWith('salesChannels')) {
            columns.visible = false;
          }
        }
      }

      this.getPriceLists();
    }

    getPriceLists() {
      ApiService.price.lists
        .list(HelpersService.getPaginator())
        .then((response) => {
          this.model = response.data.payload.list;

          $timeout(() => {
            if (this.selectedPriceList) {
              const replacedIndex = this.replacePriceList(this.selectedPriceList);

              if (replacedIndex) {
                this.selected = this.model[replacedIndex];
              }

              this.onSelectedChanged(this.selected);
            }
          }, 10);
        })
        .catch(() => {
          // noop
        });
    }

    findPriceList(id: string) {
      for (let i = 0, ii = this.model.length; i < ii; i++) {
        if (this.model[i].id === id) {
          return {
            index: i,
            list: this.model[i],
          };
        }
      }

      return undefined;
    }

    replacePriceList(priceList: PriceList) {
      const found = priceList.id ? this.findPriceList(priceList.id) : undefined;

      if (found == null) {
        return undefined;
      }

      this.model[found.index] = priceList;

      return found.index;
    }

    hasPrices() {
      return Array.isArray(this.selectedPriceList?.prices) && this.selectedPriceList.prices.length > 0;
    }

    onSelectedChanged(selected: PriceList) {
      const priceList = selected?.id ? this.findPriceList(selected.id)?.list : undefined;
      this.selectedPriceList = angular.copy(priceList ?? null);
      this.selectedPriceListChange({ $event: { priceList: this.selectedPriceList } });
    }
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/priceListPicker/priceListPicker.tpl.html',

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controllerAs: '$ctrl',
    controller: PriceListPickerController,

    bindToController: {
      enableSalesTax: '<',
      hideChannels: '<',
      selectedPriceList: '=',
      selectedPriceListChange: '&',
    },
  };
}

export const PriceListPickerDirectiveModule = angular
  .module('acme.common.directive.priceListPicker', [
    'ui.grid',
    'acme.common.service.api',
    'acme.common.service.helpers',
    BasePriceFilterModule,
  ])
  .directive('priceListPicker', PriceListPickerDirective).name;
